import { createSelector } from 'reselect';
import _isNull from 'lodash/isNull';
import { premiumCaps } from 'store/saga/entities/bound';

const getPremiumCapsEntityInfo = createSelector(
  state => state || {},
  (state, venueId) => venueId,
  (state, venueId) => ({
    loading: premiumCaps.loading(state, venueId),
    loaded: premiumCaps.loaded(state, venueId),
    data: premiumCaps.data(state, venueId),
  })
);

const selectPremiumCapsNoData = createSelector(getPremiumCapsEntityInfo, ({ data }) => _isNull(data));

export const selectPremiumCapsHasLoadedOnce = createSelector(
  getPremiumCapsEntityInfo,
  selectPremiumCapsNoData,
  ({ loaded }, noData) => loaded || !noData
);

export const selectPremiumCaps = createSelector(getPremiumCapsEntityInfo, selectPremiumCapsNoData, ({ data }, noData) =>
  noData ? [] : data
);

export const selectPremiumCapsRule = createSelector(
  (state, venueId, ruleId) => ruleId,
  getPremiumCapsEntityInfo,
  (ruleId, { data }) => data.find(({ id }) => id === ruleId)
);
